export class Venue {
	
	id: string;
	number: number;
	name: string;
	latitude: number;
	longitude: number;
	description: string;
	address: string;
	city: string;
	state: string;
	postal_code: string;
	country: string;
	website: string;
	phone: string;
	closest_airport: string;
	alternate_airports: string;
	utc_offset: string;

	upcoming_events: Venue_event[] = [];

	constructor(values: Object = {}) {
		Object.assign(this, values);
	}

}

export class Venue_event {
	id: string;
	type: string;
	name: string;
	start_date: Date;
	end_date: Date;

	constructor(values: Object = {}) {
		Object.assign(this, values);
	}
	
}